// extracted by mini-css-extract-plugin
export var carrierIcon = "_xq-0";
export var carrierLogo = "_xq-1";
export var detailsSection = "_xq-2";